import { ReactComponent as AlertTagShort } from 'assets/icons/icon-alert-tag-short.svg';

export default AlertTagShort;
